<template>
    <div class="auth_form_body">
        <div v-show="userCheckNotValidLogin" class="auth_form_bg_box flicker_animation">
            <form @submit.prevent="validateLoginBeforeSubmit" autocomplete="off">
                <div class="form-group">
                    <input type="text" v-model="identity" name="identity" class="form-control" v-validate="'required'"
                        v-bind:class="{ 'is-invalid': errors.has('identity') }" placeholder="Mobile / Email*">
                    <small class="invalid-feedback" v-if="errors.has('identity')">Please provide valid email or mobile
                        number</small>
                </div>
                <div class="row mt-5">
                    <div class="col text-center">
                        <button class="btn btn-primary" type="submit" :disabled="submitted">Next</button>
                    </div>
                </div>
            </form>
        </div>
        <div v-if="userCheckValidLogin" class="auth_form_bg_box flicker_animation">
            <form @submit.prevent="validateBeforeSubmit" autocomplete="off">
                <div class="form-group">
                    <label>OTP*</label>
                    <input type="number" maxlength="6" class="form-control" v-validate="{ required: true, min: 6 }"
                        placeholder="" v-model="otp" name="otp" v-bind:class="{ 'is-invalid': errors.has('otp') }"
                        data-vv-as="Otp" style="max-width:90px;padding: 0 5px;    text-align: center;" />
                    <small class="invalid-feedback" v-if="errors.has('otp')">{{ errors.first('otp') }}</small>
                    <span class="resent_otp_txt" v-if="resentOtpFlag"><i class="fa fa-check-square-o"
                            aria-hidden="true"></i> A new OTP has been sent to your email and mobile.</span>
                </div>
                <div class="row mt-5">
                    <div class="col text-center">
                        <button class="btn btn-primary" type="submit" v-on:disabled="submitted">Log in</button>
                    </div>
                </div>
            </form>
            <div class="row mt-4">
                <div class="col text-center">
                    <template v-if="resentOtpFlag">
                        <span class="resend_otp_txt">
                            <template v-if="countDown == 0"><span @click="resendOtpMethod">Still didn't receive an
                                    OTP?</span></template>
                            <template v-else><span class="disabled_action">Still didn't receive an
                                    OTP?</span></template>
                            <a
                                :href="`mailto:admin@lbil.ai?subject=LBIL Need Assistance Email&body=Dear LBIL Admin, %0D%0A%0D%0A I, User’s Name (${identity}), need assistance obtaining an OTP to login into LBIL. %0D%0A%0D%0A I am not receiving an OTP at my email or via SMS, and I have tried several times. %0D%0A%0D%0A Please reply to my registered email. %0D%0A%0D%0A Thank you. %0D%0A%0D%0A Best, %0D%0A%0D%0A`">
                                Need assistance?</a>
                        </span>
                    </template>
                    <template v-else>
                        <template v-if="countDown == 0">
                            <span class="resend_otp_txt">
                                Didn't receive an OTP? <span @click="resendOtpMethod">Click here to resend OTP</span>
                            </span>
                        </template>
                        <template v-else>
                            <span class="resend_otp_txt">Resend OTP in {{ countDown }}s</span>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
/*eslint-disable */
import {bus} from '@/main';
var clearTimeoutState;
import toast from '@/services/toast';
export default {
    name: 'lbilLogin',
    data() {
        return {
            email: '',
            password: '',
            submitted: false,
            isRememberMe: false,
            mblLogined: false,
            userCheckNotValidLogin: true,
            userCheckValidLogin: false,
            identity: '',
            otp: '',
            countDown: 30,
            resentOtpFlag: false
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        countDownTimer() {
            if (this.countDown > 0) {
                clearTimeoutState = setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        resendOtpMethod() {
            if (this.validateEmail(this.identity)) {
                this.mblLogined = false
            } else {
                this.mblLogined = true
            }
            if (this.mblLogined == true) {
                this.$store.dispatch('resentOtpForLoginAction', {
                    mobile: this.identity
                })
                    .then((res) => {
                        this.verfiyIdentity = this.identity
                        this.userCheckNotValidLogin = false
                        this.userCheckValidLogin = true
                        toast.success(res.data.user_msg);
                        this.countDown = 30
                        this.countDownTimer();
                        this.resentOtpFlag = true
                    }).catch((err) => {
                        toast.error(err.data.data.non_field_errors || err.data.msg);
                    })
                return;
            } else {
                this.$store.dispatch('resentOtpForLoginAction', {
                    email: this.identity
                })
                    .then((res) => {
                        this.verfiyIdentity = this.identity
                        this.userCheckNotValidLogin = false
                        this.userCheckValidLogin = true
                        toast.success(res.data.user_msg);
                        this.countDown = 30
                        this.countDownTimer();
                        this.resentOtpFlag = true
                    }).catch((err) => {
                        toast.error(err.data.data.non_field_errors || err.data.msg);
                    })
                return;
            }
        },
        showNextScreenForLogin() {
            if (this.validateEmail(this.identity)) {
                this.mblLogined = false
            } else {
                this.mblLogined = true
            }
            if (this.mblLogined == true) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.submitted = true
                        this.$store.dispatch('checkLBILLoginTypeAction', {
                            mobile: this.identity
                        })
                            .then((res) => {
                                this.verfiyIdentity = this.identity
                                this.userCheckNotValidLogin = false
                                this.userCheckValidLogin = true
                                this.submitted = false
                                toast.success(res.data.user_msg);
                                this.countDownTimer();
                            }).catch((err) => {
                                this.submitted = false
                                toast.error(err.data.data.non_field_errors || err.data.msg);
                            })
                        return;
                    }
                });
            } else {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.submitted = true
                        this.$store.dispatch('checkLBILLoginTypeAction', {
                            email: this.identity
                        })
                            .then((res) => {
                                this.verfiyIdentity = this.identity
                                this.userCheckNotValidLogin = false
                                this.userCheckValidLogin = true
                                this.submitted = false
                                toast.success(res.data.user_msg);
                                this.countDownTimer();
                            }).catch((err) => {
                                this.submitted = false
                                toast.error(err.data.data.non_field_errors || err.data.msg);
                            })
                        return;
                    }
                });
            }
        },
        validateLoginBeforeSubmit() {
            if (this.userCheckNotValidLogin) {
                this.showNextScreenForLogin();
            }
        },
        validateBeforeSubmit(e) {
            if (this.mblLogined == true) {
                this.$validator.validateAll().then((result) => {
                    this.submitted = true;
                    if (result) {
                        this.loginBtnDisabled = true
                        this.$store.dispatch('loginWithOtpLBILAction', {
                            mobile: this.verfiyIdentity,
                            otp: this.otp
                        })
                            .then((res) => {
                                bus.$emit('headerPlatformBus', "LBIL");
                                document.getElementById('preloader').style.display = "flex";
                                toast.success(res.data.msg);
                                this.submitted = false
                                this.$router.push('/lbil/');
                            }).catch((err) => {
                                toast.error(err.data.user_msg);
                                this.otp = '',
                                this.userCheckNotValidLogin = true
                                this.userCheckValidLogin = false
                                this.submitted = false
                                clearTimeout(clearTimeoutState)
                                this.countDown = 30
                            })
                        return;
                    }
                    alert('Correct them errors!');
                });
            } else {
                this.$validator.validateAll().then((result) => {
                    this.submitted = true;
                    if (result) {
                        this.loginBtnDisabled = true
                        this.$store.dispatch('loginWithOtpLBILAction', {
                            email: this.verfiyIdentity,
                            otp: this.otp
                        })
                            .then((res) => {
                                bus.$emit('headerPlatformBus', "LBIL");
                                this.$router.push('/lbil/');
                                document.getElementById('preloader').style.display = "flex";
                                toast.success(res.data.msg);
                                this.submitted = false
                            }).catch((err) => {
                                toast.error(err.data.user_msg);
                                this.otp = '',
                                this.userCheckNotValidLogin = true
                                this.userCheckValidLogin = false
                                this.mblLogined = false
                                this.submitted = false
                                clearTimeout(clearTimeoutState)
                                this.countDown = 30
                            })
                        return;
                    }
                    alert('Correct them errors!');
                });
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.auth_form_body {
    .form-control {
        height: 100%;
        width: 100%;
        height: 52px;
        font-weight: normal;
        font-size: 18px;
        border-radius: 5px;
        padding: 0 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: none;
        outline: none !important;
        box-shadow: none !important;
        color: #ffd400;
        background: rgba(255, 255, 255, 0.08);

        &:focus,
        &.active {
            border: 1px solid #ffd400;
        }

        &::placeholder,
        &::-webkit-input-placeholder,
        &::-moz-placeholder {
            color: rgba(255, 255, 255, 0.3);
        }

        &:focus::-webkit-input-placeholder {
            font-size: 0;
        }

        &:focus::-moz-placeholder {
            font-size: 0;
        }
    }

    .btn-primary {
        font-family: 'ACETONE';
        background: none;
        border: 2px solid #ffe400 !important;
        color: #ffe400 !important;
        text-transform: uppercase;
        font-size: 28px;
        padding: 8px 0;
        line-height: 1;
        height: auto;
        min-width: 110px;
        border-radius: 6px;
        box-shadow: none !important;
        outline: none !important;
        width:100%;
        &:hover {
            background: #ffe400 !important;
            color: #000000 !important;
        }
    }
.resend_otp_txt{
    color: #ffe400;
    span{cursor:pointer;&:hover{color:#00ff60;}&.disabled_action{cursor:not-allowed;color:gray;}}
    a{color: #ffe400 !important;&:hover{color:#00ff60 !important}}
}
}
</style>